import { EditSchema } from '../../schemas'
import { Variables } from './api'

export const mapper = (data: EditSchema): Variables => ({
  role: data.role,
  userId: data.id,
})
